/* eslint-disable react/prefer-es6-class, react/prefer-stateless-function */
import React from 'react';
import { NavButton, Navigation } from 'es6/components/apps/navigation';
import Localization from 'es6/services/localization';

export default React.createClass({
  displayName: 'WelcomeDiagnosticScreen',

  propTypes: {
    category: React.PropTypes.object.isRequired,
    onCourseDirectory: React.PropTypes.func.isRequired,
    onStart: React.PropTypes.func.isRequired,
  },

  render() {
    const strings = {
      title: Localization.t('diag-category-header-label-{category-title}', { 'category-title': this.props.category.name }),
      testInstructions: Localization.t('diag-test-description'),
      courseDirectory: Localization.t('diagnostic.course-directory'),
      start: Localization.t('start'),
      speakerTip: Localization.t('turn on your speakers or plug in your headphones before starting'),
      keyboardTip: Localization.t('you can use the keyboard to navigate'),
    };
    let categoryImageStyle = {
      backgroundImage: `url(${this.props.category.mainImage})`,
    };

    return (
      <div className="screen screen-welcome-diagnostic">
        <div className="screen-content">
          <h1 className="title">{strings.title}</h1>

          <div className="category-details">
            <div className="category-image-container">
              <div style={categoryImageStyle} className="category-image" />
            </div>

            <div className="category-details-description">
              <p>{this.props.category.description}</p>
              <p>{strings.testInstructions}</p>
            </div>
          </div>

          <div className="tips">
            <div className="tip tip-sound">
              <div className="tip-graphic">
                <span className="glyph glyph-volume-medium" />
              </div>
              <span className="tip-information">{strings.speakerTip}</span>
            </div>

            <div className="tip tip-keyboard">
              <div className="tip-graphic">
                <span className="ui key_help" />
              </div>
              <span className="tip-information">{strings.keyboardTip}</span>
            </div>
          </div>
        </div>

        <Navigation>
          <NavButton align="left" onClick={this.props.onCourseDirectory}>{strings.courseDirectory}</NavButton>
          <NavButton align="right" focused onClick={this.props.onStart}>{strings.start}</NavButton>
        </Navigation>
      </div>
    );
  },
});
